<template>
  <div class="row">
    <div class="col-sm-12">

      <div class="row mt-4">
        <div class="col-md-12">
          <h3>
            <strong>Feature Flag: {{ flagName }}</strong>
          </h3>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-12">
          <router-link to="/admin/feature_flags" class="btn btn-outline">
            Voltar para lista
          </router-link>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <strong>
            {{ infoTotalModels }}
          </strong>
        </div>
      </div>

      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nome da Conta</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="account in accounts" :key="account.id">
            <td>{{ account.account_id }}</td>
            <td>{{ account.name }}</td>
          </tr>
        </tbody>
      </table>

      <div class="row">
        <div class="col-md-12 my-1">
          <Pagination v-model="meta.currentPage" :total-count="meta.totalCount" :total-pages="meta.totalPages"
            @pagination="pagination" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Pagination from '@/components/shares/specialTag/Pagination'

export default {
  components: { Pagination },
  computed: {
    accounts() {
      return this.accountsList || []
    },
    decodedFlagName() {
      return decodeURIComponent(this.id || '')
    },
    flagName() {
      return this.decodedFlagName
    },
    infoTotalModels() {
      if (!this.accountsList || this.accountsList.length === 0)
        return 'Nenhum registro'

      let page = this.meta.currentPage
      let perPage = this.meta.perPage
      let startPage = perPage * (page - 1) + 1
      let lastPage = Math.min(perPage * page, this.meta.totalCount)
      return `Mostrando de ${startPage} até ${lastPage} de ${this.meta.totalCount} registro(s)`
    }
  },
  created() {
    this.loadAccounts()
  },
  data() {
    return {
      accountsList: [],
      meta: {
        currentPage: 1,
        perPage: 20,
        totalCount: 0,
        totalPages: 1
      }
    }
  },
  methods: {
    async loadAccounts() {
      try {
        const response = await this.axios.v3.get(`admin/feature_flags/${encodeURIComponent(this.decodedFlagName)}`)
        this.accountsList = response.data || []
        this.meta.totalCount = this.accountsList.length
        this.meta.totalPages = Math.ceil(this.accountsList.length / this.meta.perPage)
      } catch (error) {
        this.$notify.add('Erro ao carregar contas com feature flag', 'error')
        console.error(error)
      }
    },
    pagination(page) {
      this.meta.currentPage = page
    }
  },
  name: 'FeatureFlagsShow',
  props: {
    id: { required: true }
  }
}
</script>

<style scoped>
</style>
